module.exports = __webpack_public_path__ + "static/opengraph-img-6b4eabc73e170cefa1055c272ce5c249.png";